<template>
  <v-container>
    <v-row class="text-center">
      <v-col
        cols="12"
        class="text-h5 text-md-h5 text-lg-h4 quote pa-12 font-italic"
      >
        <p>
          "Ensinar não é transferir conhecimento mas criar as possibilidades
          para a sua própria produção ou a sua construção."
        </p>
        <p class="author">Paulo Freire</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'QuotePauloFreire',
};
</script>

<style scoped>
.quote {
  color: #f3932c;
}

.author {
  font-weight: bold;
}
</style>
